/* eslint-disable global-require */

import angular from 'angular';

import HandoverFormController from './handover.controller';

export default angular.module('autoboard.formHandover', [])
  .directive('formHandover', () => {
    'ngInject';

    return {
      controller: HandoverFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
      },
      templateUrl: require('./handover.template.html'),
    };
  })
  .name;
